///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { userRole, mode } from "./types";

export const getModeForUserRole = role => {
  switch (role) {
    case userRole.ltlPricingAnalyst:
      return mode.ltl;
    case userRole.imdlPricingAnalyst:
      return mode.imdl;
    case userRole.salesRep:
    case userRole.tlPricingAnalyst:
    case userRole.assetBasedPricingUser:
    case userRole.carrierRelationsRepresentative:
    case userRole.procurementRepresentative:
    default:
      return mode.tl;
  }
};

export default getModeForUserRole;
